import { useResendConfirmationMailMutation } from "@ac-expo/api";
import {
  Button,
  Dialog,
  DialogContent,
  useToast,
} from "@ac-expo/ui-components";
import OwnImage from "@ui/components/ui/event/OwnImage";
import mailConfirmationStore from "@web-app/src/services/MailConfirmationStore";
import { MailIcon } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

export const MailConfirmationModal = observer(() => {
  const [isOpen, setIsOpen] = useState(false);
  const userEmail = mailConfirmationStore.userEmail;
  const isModalVisible = mailConfirmationStore.getModalIsVisible();
  const { mutate } = useResendConfirmationMailMutation();
  const { toast } = useToast();

  useEffect(() => {
    if (isModalVisible) {
      setIsOpen(true);
      mailConfirmationStore.setModalVisible(false);
    }
  }, [isModalVisible]);

  if (!userEmail) {
    return null;
  }

  const submit = () => {
    mutate(
      { email: userEmail },
      {
        onError: (e) => {
          toast({ title: "Erreur", description: e.message });
        },
      }
    );
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[587px]">
        <div className="flex flex-col gap-8">
          <div className="flex h-[104px] w-full flex-col items-center gap-3">
            <OwnImage
              src="/images/logos/logo_connect_events_vertical.png"
              alt="logo avec nom Connect'Events vertical"
              className="static h-28 w-auto"
            />
          </div>
          <div className="flex w-full flex-col items-center gap-12">
            <div className="flex w-full max-w-[312px] flex-col items-center gap-5">
              <MailIcon size={24} className="text-primary-500" />
              <p className="text-center text-[20px] font-extrabold leading-[24px]">
                Vérifiez votre boîte mail
              </p>
              <p className="text-center text-[14px] font-normal leading-[21px]">
                Un email de confirmation a été envoyé à l&apos;adresse suivante
                :
                <p className="text-center text-[14px] font-bold leading-[21px]">
                  {userEmail}
                </p>
              </p>
            </div>
            <Button
              onClick={submit}
              className="h-[44px] w-full"
              variant="outline-blue"
            >
              <p className="text-[16px] font-semibold leading-[24px]">
                Renvoyer l&apos;email
              </p>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
});
